"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardLinkPreviewOption')(function discardLinkPreviewOption(state) {
    var optionState = state.optionState;
    optionState.isEnabled = null;
}));
//# sourceMappingURL=discardLinkPreviewOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-link-preview-option/lib/actions/discardLinkPreviewOption.js
// module id = 5144
// module chunks = 2